export interface Deduction {
  id: string;
  status: number;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  baseOnType: number;
  deductionDetails: DeductionDetailItem[];
}

export interface DeductionDetail {
  id: string;
  createdAt: string;
  status: number;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  effectiveFrom: string;
  applicablePerson: number;
  category: number;
  baseOnType: number;
  compensationDeductions: unknown[];
  deductionDetails: DeductionDetailItem[];
}

interface DeductionDetailItem {
  id: string;
  objectType: number;
  unitType: number;
  value: number;
  maxWageValue: number;
  baseOnType: number;
  effectiveFrom: string;
  valueDetail?: {
    code: string;
    value: number;
    name: string;
    nativeName: string;
  }[];
}

export interface DeductionListRequest {
  page?: number;
  limit?: number;
  name?: string | null;
  keyword?: string | null;
  status?: number | null;
}

export interface DeductionCreateRequest {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  applicablePerson: number;
  category: number;
  items: Item[];
  status: number;
}

interface Item {
  objectType: number;
  unitType: number;
  value: number;
  maxWageValue?: number;
  effectiveFrom: string;
  id?: string;
  baseOnType: number;
  valueDetail?: {
    code: string;
    value: number;
    name: string;
    nativeName: string;
  }[];
}

export interface DeductionUpdateRequest extends DeductionCreateRequest {
  id: string;
}

export interface DeductionListResponse extends RestAPIMetaResponse {
  items: Array<Deduction>;
}

export enum DeductionBaseOnType {
  BeforeTax = 1,
  AfterTax = 3,
}

export enum DeductionCode {
  SOCIAL_INSURANCE = "SI",
  HEALTH_INSURANCE = "HI",
  UNEMPLOYEE_INSURANCE = "UI",
  UNION_CONTRIBUTION = "UC",
  OTHER = "OTHER",
}

export enum DeductionCategory {
  INSURANCE = 1,
  UNION = 3,
  OTHER = 5,
}

export const DeductionCategoryMapping = {
  [DeductionCode.SOCIAL_INSURANCE]: DeductionCategory.INSURANCE,
  [DeductionCode.HEALTH_INSURANCE]: DeductionCategory.INSURANCE,
  [DeductionCode.UNEMPLOYEE_INSURANCE]: DeductionCategory.INSURANCE,
  [DeductionCode.UNION_CONTRIBUTION]: DeductionCategory.UNION,
  [DeductionCode.OTHER]: DeductionCategory.OTHER,
};

export enum DeductionUnitType {
  PERCENT = 1,
  AMOUNT = 3,
}

export enum DeductionObjectType {
  COMPANY = 1,
  EMPLOYEE = 3,
}

export enum DeductionApplicablePerson {
  LOCAL = 1,
  FOREIGN = 3,
}

export enum DeductionValueDetailType {
  HT = "HT",
  TS = "TS",
  TNLD = "TNLD",
}
